// AbortSignal.timeout needs Chrome 103 and AbortSignal.any Chrome 116; the Android
// app (minSdk 24) can run an older WebView, so both fall back to AbortController.

function timeoutReason(): Error {
  try {
    return new DOMException("signal timed out", "TimeoutError");
  } catch {
    // intentional: no DOMException constructor, an Error with the same name stands in.
    const err = new Error("signal timed out");
    err.name = "TimeoutError";
    return err;
  }
}

/** A signal that aborts after `ms` with a TimeoutError reason, like AbortSignal.timeout. */
export function timeoutSignal(ms: number): AbortSignal {
  if (typeof AbortSignal.timeout === "function") return AbortSignal.timeout(ms);
  const controller = new AbortController();
  setTimeout(() => controller.abort(timeoutReason()), ms);
  return controller.signal;
}

/** A signal that aborts when any input aborts, with that input's reason, like AbortSignal.any. */
export function anySignal(signals: readonly AbortSignal[]): AbortSignal {
  if (typeof AbortSignal.any === "function") return AbortSignal.any([...signals]);
  const controller = new AbortController();
  const already = signals.find((s) => s.aborted);
  if (already) {
    controller.abort(already.reason);
    return controller.signal;
  }
  const cleanup = (): void => {
    for (const s of signals) s.removeEventListener("abort", onAbort);
  };
  function onAbort(this: AbortSignal): void {
    cleanup();
    controller.abort(this.reason);
  }
  for (const s of signals) s.addEventListener("abort", onAbort);
  return controller.signal;
}
